// do not delete this file
import moment from 'moment'
import lodash from 'lodash'
import autosize from 'autosize'
import HttpClient from '@/HttpClients/HttpClient'
import ErrorHandler from '@/HttpClients/ErrorHandler'
import Loader from '@helpers/Loader'

window.moment = moment
window.lodash = lodash
window.autosize = autosize
window.HttpClient = HttpClient
window.ErrorHandler = ErrorHandler
window.Loader = Loader

$(function () {
    window.stripHtml = function (string) {
        return $('<div/>').html(string).text()
    }

    $('.js-custom-select').select2({
        // we will use bootstrap theme
        theme: 'bootstrap4',
        // if we don't specify width as 100% here, select2 sometimes messes up width
        // if custom width is needed, then use a different class
        width: '100%',
        // This works on select2 4.0.13
        // docs: https://github.com/select2/select2/blob/4.0.13/docs/pages/03.configuration/01.options-api/docs.md
        containerCssClass: 'custom-select-selection-container',
        // This works on select2 4.1+
        // docs: https://select2.org/configuration/options-api
        selectionCssClass: 'custom-select-selection-container'
    })

    /*
     * When you change the value the select via select2, it triggers
     * a 'change' event, but the jquery validation plugin
     * only re-validates on 'blur', so even if we change the
     * select will still show as invalid
     * So when value changes, we will trigger blur so that
     * jquery validate will revallidate it
     *
     */
    $(document).on('change', '.js-custom-select', function () {
        $(this).trigger('blur')
    })

    $(document).on('change', '.custom-file-input', function () {
        let input = $(this)
        let label = input.closest('.custom-file').find('.custom-file-label')
        const fileName = (this.files[0] || {}).name || label.data('original-label') || 'Choose File'
        label.addClass('selected').text(fileName)
    })

    $(document).on('click', '.admin-logout', function (event) {
        event.preventDefault()
        event.stopPropagation()

        logout()
    })

    function logout () {
        let formData = new FormData()

        let url = window.config.logoutRoute

        let options = {
            url: url,
            data: formData,
            method: 'POST',

            // contentType:false and processData:false are needed when sending formData
            contentType: false,
            processData: false,
            disableLoader: false
        }

        const client = new HttpClient(options)

        client.acceptJson()
        client.setSuccessHandler(logoutSuccessHandler)

        client.send()
    }

    function logoutSuccessHandler (response, textStatus, jqXHR, httpClient) {
        if (response.success) {
            httpClient.dontStopLoader()
            location.reload()
        }
    }

    /**
     * This is for preventing # in the url when user clicks on links with href="#"
     */
    $(document).on('click', 'a[href="#"]', function (event) {
        event.preventDefault()
    })

    $('body').tooltip({
        selector: '[data-toggle=tooltip]'
    })

    if (!window.dontAutomaticallyStopLoader) {
        // Sometimes, on super fast systems, the loader hides before page is fully rendered
        // and thus everything looks broken for a fraction of a second
        // So to avoid such scenarios, adding a 1 seconds delay to stopping loader
        const timer = setTimeout(function () {
            Loader.stop()
        }, 1000)
    }
})
